module.exports = __webpack_public_path__ + "img/404.59c805eb.png";